import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
export var MERCURE_OPENING_STATUS = {
  'fr-FR': false,
  'nl-BE': false,
  'fr-BE': false,
  'de-DE': false,
  'es-ES': false,
  'it-IT': false,
  'fr-LU': false,
  'nl-NL': false,
  'de-AT': false,
  'pt-PT': false,
  'de-CH': false,
  'it-CH': false,
  'fr-CH': false,
  'en-GB': false
};
export var STATUS = {
  REQUESTING_PAYEMENT: {
    id: 0,
    step: 0,
    shipped: false
  },
  VALIDATED: {
    id: 1,
    step: 0,
    shipped: true
  },
  PAID_WAITING_STOCK: {
    id: 2,
    step: 1,
    shipped: true
  },
  ONGOING_PREPARATION: {
    id: 3,
    step: 2,
    shipped: true
  },
  DELIVERY_TO_CARRIER: {
    id: 4,
    step: 2,
    shipped: true
  },
  DELIVERY_IN_PROGRESS: {
    id: 5,
    step: 3,
    shipped: true
  },
  DELIVERED: {
    id: 6,
    step: 4,
    shipped: false
  },
  CANCELED: {
    id: 7,
    step: 4,
    shipped: false
  },
  VALIDATED_WAITING_STOCK: {
    id: 8,
    step: 4,
    shipped: false
  },
  DELIVERY_TO_CARRIER_DUPLICATED: {
    id: 9,
    step: 4,
    shipped: false
  },
  APOINTEMENT: {
    id: 10,
    step: 4,
    shipped: false
  },
  DELIVERED_TO_STORE: {
    id: 11,
    step: 4,
    shipped: false
  },
  DELIVERED_TO_RELAY: {
    id: 12,
    step: 4,
    shipped: false
  },
  EXCHANGED: {
    id: 13,
    step: 4,
    shipped: false
  },
  REFUNDED: {
    id: 14,
    step: 4,
    shipped: false
  }
};